import {useQuery} from "@tanstack/react-query"
import {konductorService} from "services"

/**
 * Loads the per-client Konductors ("SAM AI Assistant") chatbot configuration
 * from edular-core. The value is cached so the sidebar and the iframe view
 * share a single request.
 *
 * `enabled` is part of the query key on purpose: when the acting user loses AI
 * Assistant access (e.g. profile switch), the hook is called with
 * `enabled = false`, which resolves to a separate, empty cache entry instead of
 * serving the previously cached config to a user who should not see it.
 */
export function useKonductorConfig(enabled = true) {
    const query = useQuery(["konductor-chatbot-config", enabled], () => konductorService.getChatbotConfig(), {
        enabled,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false
    })

    return {
        ...query,
        // Never surface a config (stale or otherwise) while disabled.
        data: enabled ? query.data : undefined
    }
}
